import { dateFormatter } from './date';

export const documentDateFormatter = (dateToFormat?: string) => {
  if (!dateToFormat) return;
  const dateObj = new Date(dateToFormat);
  return dateFormatter({
    date: dateObj,
    locales: 'en-US',
    format: { dateStyle: 'long' },
  });
};
